

import { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function useQueryParam(
  key: string,
  defaultValue?: string
): [string, (newValue: string | null) => void] {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setValue(params.get(key) || "");
  }, [key, location.search]);

  const updateParam = useCallback(
    (newValue: string | null) => {
      const params = new URLSearchParams(location.search);

      if (newValue && newValue.trim() !== "") {
        params.set(key, newValue);
      } else {
        params.delete(key);
      }

      navigate(
        {
          pathname: location.pathname,
          search: params.toString() ? `?${params.toString()}` : "",
        },
        { replace: true }
      );

      setValue(newValue || "");
    },
    [key, location, navigate]
  );

   const _value = value || defaultValue?.toString() || "";
  return [ _value, updateParam];
}
